import { Link } from "react-router-dom";
import type { Category } from "@/types/content";
import { categoryCount } from "@/lib/content";
import { getCover } from "@/assets/covers";

interface CategoryGridProps {
  categories: Category[];
}

export default function CategoryGrid({ categories }: CategoryGridProps) {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-5">
      {categories.map((category) => (
        <Link
          key={category.key}
          to={`/category/${category.key}`}
          className="group relative block cursor-pointer overflow-hidden rounded-lg border border-background-300/50 bg-background-100"
        >
          <div className="relative h-[150px] w-full overflow-hidden md:h-[190px]">
            <img
              src={getCover(category.cover)}
              alt={`${category.name}分类封面`}
              title={`${category.name} · 亚洲无码分类`}
              className="h-full w-full object-cover object-top transition duration-700 ease-smooth group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/50 to-transparent" />
          </div>
          <div className="absolute inset-x-0 bottom-0 p-3 md:p-4">
            <div className="flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded bg-primary-500/95 text-background-950">
                <i className={`${category.icon} text-sm`} />
              </span>
              <h3 className="font-heading text-sm font-semibold text-foreground-50 md:text-[15px]">
                {category.name}
              </h3>
            </div>
            <div className="mt-1.5 flex items-center justify-between">
              <span className="text-[10px] uppercase tracking-[0.18em] text-foreground-500">
                {category.en}
              </span>
              <span className="text-[11px] text-primary-300">{categoryCount(category.key)} 部</span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}